import 'bootstrap';

let menuTimeOut;
let onMenu;
let menuImageTimeOut;

$('.mega-menu .wrapper > ul > li').on('mouseenter', function(e){
    const menuItem = this
    if(onMenu){
        $(menuItem).find('.mega-menu-sub').show();
    } else {
        menuTimeOut = setTimeout(function () {
            $(menuItem).find('.mega-menu-sub').show();
        }, 300)
    }
    onMenu = true;
});

$('.mega-menu .wrapper > ul > li ').on('mouseleave', function(e){
    clearTimeout(menuTimeOut);
    $(this).find('.mega-menu-sub').hide();

    let banner = $('.banner');
    let bannerTitle = banner.children('.title').children('h2');
    let bannerSubtitle = banner.children('.title').children('h3');
    let bannerData = $('.navbar-brand');

    banner.css("background-image", "url(" + bannerData.data('menu-image') +")");
    bannerTitle.text(bannerData.data('menu-title')).css("color", bannerData.data('menu-title-color'));
    bannerSubtitle.text(bannerData.data('menu-subtitle')).css("color", bannerData.data('menu-subtitle-color'));
});

$('.mega-menu .wrapper > ul').on('mouseleave', function(e){
    onMenu = false;
});

$('.mega-menu-main-cat').on('mouseenter', function(e) {
    let banner = $('.banner');
    let bannerTitle = banner.children('.title').children('h2');
    let bannerSubtitle = banner.children('.title').children('h3');
    let bannerData = (typeof $(this).data('menu-image') != 'undefined') ? $(this): $('.navbar-brand');

    menuImageTimeOut = setTimeout(function () {
        banner.css("background-image", "url(" + bannerData.data('menu-image') +")");
        bannerTitle.text(bannerData.data('menu-title')).css("color", bannerData.data('menu-title-color'));
        bannerSubtitle.text(bannerData.data('menu-subtitle')).css("color", bannerData.data('menu-subtitle-color'));
    }, 100)
});

$('.sideways-sub').on('mouseenter', function(e) {
    let banner = $('.banner');
    let bannerTitle = banner.children('.title').children('h2');
    let bannerSubtitle = banner.children('.title').children('h3');
    const parent = $(this).parents('.sideways-cat-item');
    const parentAnchor = parent.children('.mega-menu-main-cat');
    let bannerData = (typeof $(this).data('menu-image') != 'undefined') ? $(this) : parentAnchor;

    menuImageTimeOut = setTimeout(function () {
        banner.css("background-image", "url(" + bannerData.data('menu-image') +")");
        bannerTitle.text(bannerData.data('menu-title')).css("color", bannerData.data('menu-title-color'));
        bannerSubtitle.text(bannerData.data('menu-subtitle')).css("color", bannerData.data('menu-subtitle-color'));
    }, 100)
});

$('.mega-menu-main-cat').on('mouseleave', function(e) {
    clearTimeout(menuImageTimeOut);
});
